import { ResponsiveContainer, BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, Legend } from "recharts";
import { useState } from "react";
import { TrendingUp, Hourglass } from "lucide-react";
import { LastChanceDialog } from "./LastChanceDialog";

const STAGES = [["invited", "Invited", "#CBD5E1"], ["opened", "Opened", "#7DD3FC"], ["joined", "Joined", "#374B5C"], ["bought", "Bought a package", "#FF8166"]];
const pct = (a, b) => (b ? `${Math.round((a / b) * 100)}%` : "—");

function LastChanceCell({ b, onOpen }) {
  const lc = b.last_chance || { sent: 0, left: 0 };
  if (!lc.left) return <span className="text-xs muted" data-testid="last-chance-done">{lc.sent ? `Sent to ${lc.sent}` : "Nobody left"}</span>;
  return <button onClick={() => onOpen(b.id)} className="btn-ghost btn-sm whitespace-nowrap" data-testid="last-chance-open-btn"><Hourglass size={13} />Last chance ({lc.left})</button>;
}

function Rates({ batches, onOpen }) {
  return (
    <div className="overflow-x-auto"><table className="w-full text-xs" data-testid="invite-funnel-table">
      <thead className="text-left muted"><tr><th className="py-2 pr-3">Batch</th><th className="py-2 pr-3">Opened</th><th className="py-2 pr-3">Joined</th><th className="py-2 pr-3">Bought</th><th className="py-2 pr-3">Joined → bought</th><th className="py-2">Follow-up</th></tr></thead>
      <tbody>{batches.map((b) => { const f = b.funnel; return (
        <tr key={b.id} className="border-t border-slate-100" data-testid="invite-funnel-row">
          <td className="py-2 pr-3 font-medium">{b.name}</td>
          <td className="py-2 pr-3">{f.opened} <span className="muted">({pct(f.opened, f.invited)})</span></td>
          <td className="py-2 pr-3">{f.joined} <span className="muted">({pct(f.joined, f.invited)})</span></td>
          <td className="py-2 pr-3">{f.bought} <span className="muted">({pct(f.bought, f.invited)})</span></td>
          <td className="py-2 pr-3 font-semibold text-[#FF8166]">{pct(f.bought, f.joined)}</td>
          <td className="py-2"><LastChanceCell b={b} onOpen={onOpen} /></td>
        </tr>); })}</tbody>
    </table></div>
  );
}

export function InviteFunnel({ batches, reload }) {
  const [open, setOpen] = useState(null);
  if (!batches.length) return null;
  const data = batches.slice(0, 8).reverse().map((b) => ({ name: b.name.length > 22 ? `${b.name.slice(0, 21)}…` : b.name, ...b.funnel }));
  return (
    <section className="card p-5" data-testid="invite-funnel">
      <h2 className="font-bold flex items-center gap-2 mb-1"><TrendingUp size={18} />Invite funnel</h2>
      <p className="text-xs muted mb-3">Per batch: invites sent, links opened, accounts created, and providers who bought a paid package after joining.</p>
      <div className="h-72"><ResponsiveContainer><BarChart data={data} barGap={2}><CartesianGrid stroke="#eef2f6" vertical={false} /><XAxis dataKey="name" fontSize={10} /><YAxis allowDecimals={false} fontSize={10} /><Tooltip /><Legend wrapperStyle={{ fontSize: 12 }} />
        {STAGES.map(([k, label, c]) => <Bar key={k} dataKey={k} name={label} fill={c} radius={[4, 4, 0, 0]} />)}</BarChart></ResponsiveContainer></div>
      <Rates batches={batches} onOpen={setOpen} />
      <LastChanceDialog batchId={open} onClose={() => setOpen(null)} onSent={reload} />
    </section>
  );
}
